import { useState, useEffect } from 'react';
import { callFrameSubject } from '../../extensions-framework';
export const useIsCallFrameOpen = () => {
    const [isOpen, setOpen] = useState(false);
    useEffect(() => {
        const callFrameSubscription = callFrameSubject.subscribe((callFrameComponent) => {
            setOpen(Boolean(callFrameComponent));
        });
        return () => {
            callFrameSubscription.unsubscribe();
        };
    }, []);
    return isOpen;
};
